import { ISearchQueryParams, PriceOptions } from '../types/bookingFormTypes';

export const formatDuration = ({ priceOption, hours, nights }: ISearchQueryParams) => {
  const unit = getPriceUnit(priceOption);
  let duration: any = 1;
  if (priceOption === PriceOptions.Hour) {
    duration = hours;
  } else if (priceOption === PriceOptions.Day) {
    duration = nights;
  }

  return `${duration} ${unit}`;
};

export const getPriceUnit = (priceOption: PriceOptions) => {
  const unit = priceOption === PriceOptions.Hour ? 'giờ' : 'đêm';

  return unit;
};
